export type Position = 'QB' | 'RB' | 'WR' | 'TE' | 'OL' | 'DL' | 'LB' | 'CB' | 'S' | 'K';

export const RATING_KEYS = [
  'SPD', 'ACC', 'AGI', 'STR', 'THP', 'THA', 'CTH', 'CIT', 'RTE', 'BLK', 'PRS', 'TAK', 'COV', 'KPW', 'KAC',
] as const;
export type RatingKey = (typeof RATING_KEYS)[number];
export type Ratings = Record<RatingKey, number>;

export interface Player {
  id: string;
  number: number;
  pos: Position;
  ratings: Ratings;
  stamina: number;
}

/** One player spot in a formation, in yards relative to the ball. x: right of the QB is positive. y: downfield is positive. */
export interface FormationSlot {
  pos: Position;
  x: number;
  y: number;
}

export interface Formation {
  id: string;
  name: string;
  side: 'offense' | 'defense';
  slots: FormationSlot[];
}

export type RouteType = 'slant' | 'curl' | 'flat' | 'out' | 'go' | 'post' | 'corner' | 'cross' | 'wheel' | 'screen';
export type PlayType = 'run' | 'short' | 'deep' | 'playaction';
export type Shell = 'man' | 'cover2' | 'cover3';

export interface PlayRoute {
  /** Index into the formation's slots. */
  slot: number;
  route: RouteType;
  /** Optional depth override in yards for the route's stem. */
  depth?: number;
}

export interface Play {
  id: string;
  type: PlayType;
  name: string;
  formation: Formation;
  routes: PlayRoute[];
  /** Slot index of the first read (icon A). */
  primaryRead: number;
  playable: boolean;
  /** Run plays: where the back heads before turning upfield (ball-relative), and whether it is a pitch. */
  run?: { aim: { x: number; y: number }; toss: boolean };
}

export type CatchTiming = 'perfect' | 'good' | 'miss' | 'none';

export interface DriveState {
  ballOn: number;
  down: number;
  toGo: number;
  plays: number;
}
